import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonRow,
  IonTitle,
  IonToolbar,
  LoadingController,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FreightAvailableMutationsService } from '../freight-available-mutations.service';
import { IFreightAvailableDetailed } from '@okcargo-apps/shared-domain';
import { AnalyticsService } from '@okcargo-apps/shared-infrastructure-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { FreightAvailableDetailModalDataComponent } from '../freight-available-detail-modal-data/freight-available-detail-modal-data.component';

@Component({
  selector: 'lib-freight-available-accept-modal',
  templateUrl: './freight-available-accept-modal.component.html',
  styleUrls: ['./freight-available-accept-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FormsModule,
    IonCheckbox,
    IonItem,
    IonGrid,
    IonRow,
    IonCol,
    IonContent,
    IonFooter,
    IonTitle,
    IonIcon,
    IonButton,
    IonButtons,
    IonToolbar,
    IonHeader,
    DateFnsModule,
    TranslateModule,
    FreightAvailableDetailModalDataComponent,
  ],
})
export class FreightAvailableAcceptModalComponent implements OnInit {
  // comes from the component that opens the modal
  public freight!: IFreightAvailableDetailed;

  private readonly freightAvailableMutationsService = inject(FreightAvailableMutationsService);
  private readonly modalCtrl = inject(ModalController);
  private readonly loadingCtrl = inject(LoadingController);
  private readonly translate = inject(TranslateService);
  private readonly analyticsService = inject(AnalyticsService);

  public isTermsChecked = false;
  public hasError = false;

  ngOnInit(): void {
    this.analyticsService.logEvent('accept_available_freight_view');
  }

  public cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public async confirm(): Promise<boolean | undefined> {
    if (!this.isTermsChecked) {
      return (this.hasError = true);
    } else {
      const loading = await this.loadingCtrl.create({
        message: this.translate.instant('general.send_data'),
      });
      loading.present();

      await this.freightAvailableMutationsService.acceptFreightAssignationFromMarket(this.freight.id);

      // TODO recover this
      // If they is driver, assign the freight to himself
      // if (this.account.capabilities.includes(ECapabilities.INTERACT_WITH_STOPS)) {
      //   this.freightService.setDriverAssignation({
      //     // journeyId: this.freight.journeyId,
      //     driverId: this.account.id,
      //     driverName: this.account.firstName + ' ' + this.account.lastName,
      //     // collaboratorId: 0,
      //     // collaboratorName: '',
      //     // driverExclusivePartnerId: 0,
      //     // freightId: ''
      //   });
      // }

      await new Promise((resolve) => setTimeout(resolve, 1500));

      this.analyticsService.logEvent('accept_available_freight_sent');

      await loading.dismiss();

      return this.modalCtrl.dismiss(this.freight.id, 'confirm');
    }
  }
}
